var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabManual(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.97,
    height: 17.97,
    viewBox: "0 0 17.97 17.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27175",
    "data-name": "Group 27175",
    transform: "translate(14.143 0) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2821",
    "data-name": "Rectangle 2821",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.413,
    height: 3.998,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 4.413,
    height: 2.998,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_1",
    "data-name": "Union 1",
    transform: "translate(0 4.997)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.348,14.8.06,11.444a.415.415,0,0,1-.058-.2H0V2A2,2,0,0,1,2,0H3.413a2,2,0,0,1,2,2v9.242h0a.413.413,0,0,1-.058.2L3.065,14.8a.416.416,0,0,1-.716,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.706076145172119 13.5495491027832 L 4.412600040435791 11.04445457458496 L 4.412600040435791 1.999802827835083 C 4.412600040435791 1.44851279258728 3.96409010887146 1.00000274181366 3.412800073623657 1.00000274181366 L 1.999799966812134 1.00000274181366 C 1.448510050773621 1.00000274181366 1 1.44851279258728 1 1.999802827835083 L 1 11.04748249053955 L 2.706076145172119 13.5495491027832 M 2.706300020217896 15.00412273406982 C 2.567480087280273 15.00412273406982 2.42864990234375 14.93595314025879 2.348099946975708 14.79960250854492 L 0.06030001863837242 11.44440269470215 C 0.0218100193887949 11.37905311584473 0.00340002030134201 11.30972290039062 0.001940020243637264 11.24190235137939 L 2.021789491379877e-08 11.24190235137939 L 2.021789491379877e-08 1.999802827835083 C 2.021789491379877e-08 0.8955028057098389 0.8955000042915344 2.797546358124237e-06 1.999799966812134 2.797546358124237e-06 L 3.412800073623657 2.797546358124237e-06 C 4.517099857330322 2.797546358124237e-06 5.412600040435791 0.8955028057098389 5.412600040435791 1.999802827835083 L 5.411409854888916 11.24190235137939 C 5.409299850463867 11.30836296081543 5.390910148620605 11.37608242034912 5.35319995880127 11.43990325927734 L 3.064500093460083 14.79960250854492 C 2.983950138092041 14.93595314025879 2.845119953155518 15.00412273406982 2.706300020217896 15.00412273406982 Z",
    stroke: "none",
    fill: "#1c1c1c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabManual);
export default __webpack_public_path__ + "static/media/tab-manual.1928932507c3507322da892200d3655e.svg";
export { ForwardRef as ReactComponent };